// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","shareButton":"_2hKTUDNQMj-pbSclwQqPl5","twitterToolTip":"_1zWjWWf7LCN6hyII29X-Pr"};